export default "__VITE_ASSET__CHmU6Jx3__"